export default "__VITE_ASSET__BEeAXqmS__"